import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function About() {
    return (
        <section className="min-h-screen bg-appBg dark:bg-appDark py-6 px-6">

            <div className="max-w-6xl mx-auto">

                {/* TITLE */}
                <h1 className="text-4xl md:text-5xl font-bold text-titleLight dark:text-titleDark mb-10">
                    About ClickBoard
                </h1>

                {/* CONTENT BOX */}
                <div className="bg-card dark:bg-cardDark rounded-[28px] border border-borderLight dark:border-borderDark p-8 md:p-10">

                    {/* INTRO */}
                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        ClickBoard is a fast, simple, and secure online clipboard designed to instantly transfer text between devices—without login, installation, or complicated setup. Whether on a laptop, smartphone, or tablet, you can move text across devices in seconds using an easy code-based system.
                    </p>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        In today’s digital world, switching between devices is common, but transferring text can be inconvenient. Traditional methods like email or messaging apps often involve multiple steps or delays. ClickBoard solves this by providing a quick, efficient way to share text directly through your browser.
                    </p>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Just paste your text, generate a unique code, and use that code on another device to retrieve your text instantly—no technical knowledge required.
                    </p>

                    {/* WHY */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        Why ClickBoard Exists
                    </h2>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        ClickBoard was created to simplify everyday digital tasks by eliminating unnecessary steps in text sharing. Unlike emailing or messaging yourself, ClickBoard offers a lightweight, fast, and accessible tool for quick transfers.
                    </p>

                    {/* FEATURES */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        What Makes ClickBoard Different
                    </h2>

                    <ul className="list-disc ml-6 text-textMain dark:text-textDark space-y-2 mb-6">
                        <li>No login or account needed</li>
                        <li>No app installation required</li>
                        <li>Works on all modern devices and browsers</li>
                        <li>Instant text transfer with a unique code</li>
                        <li>Clean, user-friendly interface</li>
                        <li>Completely free</li>
                    </ul>

                    {/* SECURITY */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        Security and Privacy
                    </h2>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Your privacy is important. Only users with the correct code can access your text. Data is temporary and deleted automatically after use, ensuring nothing is stored permanently or shared publicly.
                    </p>

                    {/* USERS */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        Who Uses ClickBoard
                    </h2>

                    <ul className="list-disc ml-6 text-textMain dark:text-textDark space-y-2 mb-6">
                        <li>Students transferring notes</li>
                        <li>Developers sharing code snippets</li>
                        <li>Professionals sending quick links</li>
                        <li>Anyone needing fast, simple text transfer</li>
                    </ul>

                    {/* MISSION */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        Our Mission
                    </h2>

                    <p className="text-textMain dark:text-textDark leading-8">
                        We aim to streamline digital workflows by making text sharing fast, secure, and easy for everyone. We continue to improve ClickBoard’s performance and features to make it one of the most reliable and user-friendly tools for daily use.
                    </p>

                </div>

                <Footer />

            </div>

        </section>
    );
}